import { msUtil } from 'core/ms_util.js';
Handlebars.registerHelper('relativeTime', function(context, block) {
  return msUtil.relativeTime(context);
});